/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import React from 'react';
import { BoardSelectOrganizationView } from 'app/scripts/views/board-menu/BoardSelectOrganizationView';
import { ChangeBoardAddMemberPermsView } from 'app/scripts/views/board-menu/ChangeBoardAddMemberPermsView';
import { ChangeBoardCommentingPermsView } from 'app/scripts/views/board-menu/ChangeBoardCommentingPermsView';
import { VotingSettingsView } from 'app/scripts/views/power-ups/VotingSettingsView';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/pop-over';
const { View } = require('app/scripts/views/internal/view');
import { l } from 'app/scripts/lib/localize';
import { BoardMenuSettings } from 'app/src/components/BoardMenuSettings';
import { renderComponent } from 'app/src/components/ComponentWrapper';
import { Analytics } from '@trello/atlassian-analytics';
import { Organization } from 'app/scripts/models/organization';
import { TrelloWindow } from '@trello/window-types';
import { mapPowerUpId } from '@trello/config';
declare const window: TrelloWindow;

class BoardSettingsView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'settings';

    this.prototype.className = 'board-menu-content-frame';

    this.prototype.events = {
      'click .js-change-org:not(.disabled)': 'changeOrg',

      'click .js-toggle-covers:not(.disabled)': 'toggleCovers',

      'click .js-toggle-map-marker': 'toggleMapMarker',

      'click .js-change-comments:not(.disabled)': 'changeCommentingPerms',
      'click .js-change-voting:not(.disabled)': 'changeVotingPerms',
      'click .js-change-add-members:not(.disabled)': 'changeAddMemberPerms',

      'click .js-toggle-org-mem-join:not(.disabled)': 'toggleSelfJoin',

      'click .js-change-cookie-settings': 'changeCookieSettings',
    };
  }

  initialize({ sidebarView }: { sidebarView: unknown }) {
    this.sidebarView = sidebarView;
    this.makeDebouncedMethods('render');

    this.listenTo(this.model, 'change', this.renderDebounced);
  }

  render() {
    const data = this.model.toJSON({ prefs: true, url: true, labels: true });

    data.cardCovers = data.prefs.cardCovers;
    const organization = this.model.getOrganization() as
      | Organization
      | undefined;
    data.orgDisplayName = organization?.get('displayName');
    data.hasOrg = Boolean(organization?.id);
    data.votingEnabled = this.model.isPowerUpEnabled('voting');
    data.commentsDisplay = l(['board pref perms', this.model.getCommentPerm()]);
    data.votingDisplay = l(['board pref perms', this.model.getPref('voting')]);
    data.invitationsDisplay = l([
      'board pref perms',
      this.model.getInvitePerm(),
    ]);
    data.isMapMarkerColorFFEnabled = this.model.isMapMarkerColorFeatureFlagEnabled();
    data.isMapMarkerColorSettingEnabled = this.model.isMapMarkerColorSettingEnabled();
    const userOwnsBoard = this.model.owned();
    const userIsAdminInPaidWorkspace =
      organization?.owned() && organization?.getPaidStatus() !== 'free';
    data.canChangeOrg = userOwnsBoard || userIsAdminInPaidWorkspace;
    data.isTemplate = this.model.isTemplate();

    if (this.unmountBoardSettingsMenu) {
      this.unmountBoardSettingsMenu();
    }

    this.unmountBoardSettingsMenu = renderComponent(
      React.createElement(BoardMenuSettings, {
        ...data,
        editable: this.model.editable(),
        owned: this.model.owned(),
      }),
      this.$el[0],
    );

    return this;
  }

  remove() {
    this.unmountBoardSettingsMenu?.();
    return super.remove(...arguments);
  }

  changeOrg(e: MouseEvent) {
    stopPropagationAndPreventDefault(e);
    if (e.target instanceof Element) {
      PopOver.toggle({
        elem: $(e.target).closest('a'),
        view: BoardSelectOrganizationView,
        options: { model: this.model, modelCache: this.modelCache },
      });

      this.sidebarView.sendClickedDrawerNavItemEvent('settings', 'changeOrg');
    }
  }

  toggleCovers(e: MouseEvent) {
    stopPropagationAndPreventDefault(e);
    const traceId = Analytics.startTask({
      taskName: 'edit-board/prefs/cardCovers',
      source: 'boardMenuDrawerSettingsScreen',
    });
    this.sidebarView.sendClickedDrawerNavItemEvent('settings', 'cardCovers', {
      cardCoversEnabled: this.model.getPref('cardCovers'),
      taskId: traceId,
    });
    this.model.setPrefWithTracing(
      'cardCovers',
      !this.model.getPref('cardCovers'),
      {
        taskName: 'edit-board/prefs/cardCovers',
        source: 'boardMenuDrawerSettingsScreen',
        traceId,
        next: (err: Error) => {
          if (!err) {
            Analytics.sendUpdatedBoardFieldEvent({
              field: 'cardCoversPref',
              value: this.model.getPref('cardCovers'),
              source: 'boardMenuDrawerSettingsScreen',
              containers: {
                board: {
                  id: this.model.id,
                },
                organization: {
                  id: this.model.getOrganization()?.id,
                },
              },
              attributes: {
                taskId: traceId,
              },
            });
          }
        },
      },
    );
  }

  changeCommentingPerms(e: MouseEvent) {
    stopPropagationAndPreventDefault(e);

    if (e.target instanceof Element) {
      PopOver.toggle({
        elem: $(e.target).closest('a'),
        view: new ChangeBoardCommentingPermsView({
          model: this.model,
          modelCache: this.modelCache,
        }),
      });

      this.sidebarView.sendClickedDrawerNavItemEvent(
        'settings',
        'commentPerms',
      );
    }
  }

  changeVotingPerms(e: MouseEvent) {
    stopPropagationAndPreventDefault(e);

    if (e.target instanceof Element) {
      PopOver.toggle({
        elem: $(e.target).closest('a'),
        view: new VotingSettingsView({
          model: this.model,
          modelCache: this.modelCache,
        }),
      });

      this.sidebarView.sendClickedDrawerNavItemEvent('settings', 'votingPerms');
    }
  }

  changeAddMemberPerms(e: MouseEvent) {
    stopPropagationAndPreventDefault(e);

    if (e.target instanceof Element) {
      PopOver.toggle({
        elem: $(e.target).closest('a'),
        view: new ChangeBoardAddMemberPermsView({
          model: this.model,
          modelCache: this.modelCache,
        }),
      });

      this.sidebarView.sendClickedDrawerNavItemEvent(
        'settings',
        'invitationsPerms',
        { invitationsEnabled: this.model.getPref('invitations') },
      );
    }
  }

  toggleMapMarker(e: MouseEvent) {
    stopPropagationAndPreventDefault(e);
    const coloredMapMarkersSetting = this.model.getPluginDataByKey(
      mapPowerUpId,
      'shared',
      'enableColoredMapMarkers',
      true,
    );

    this.model.setPluginDataByKey(
      mapPowerUpId,
      'shared',
      'enableColoredMapMarkers',
      !coloredMapMarkersSetting,
    );

    this.model.trigger('change:mapMarkers');
    this.render();
  }

  toggleSelfJoin(e: MouseEvent) {
    stopPropagationAndPreventDefault(e);
    const traceId = Analytics.startTask({
      taskName: 'edit-board/prefs/selfJoin',
      source: 'boardMenuDrawerSettingsScreen',
    });
    this.sidebarView.sendClickedDrawerNavItemEvent('settings', 'selfJoin', {
      selfJoinEnabled: this.model.getPref('selfJoin'),
      taskId: traceId,
    });
    this.model
      .setPrefWithTracing('selfJoin', !this.model.getPref('selfJoin'), {
        taskName: 'edit-board/prefs/selfJoin',
        source: 'boardMenuDrawerSettingsScreen',
        traceId,
        next: (err: Error) => {
          if (!err) {
            Analytics.sendUpdatedBoardFieldEvent({
              field: 'selfJoinPref',
              value: this.model.getPref('selfJoin'),
              source: 'boardMenuDrawerSettingsScreen',
              containers: {
                board: {
                  id: this.model.id,
                },
                organization: {
                  id: this.model.getOrganization()?.id,
                },
              },
              attributes: {
                taskId: traceId,
              },
            });
          }
        },
      })
      .save();
  }

  changeCookieSettings() {
    this.sidebarView.sendClickedDrawerNavItemEvent('settings', 'cookieConsent');
    return window.trelloCookieConsentDialog();
  }
}

BoardSettingsView.initClass();
export { BoardSettingsView };
